var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 -4 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_svg__export",
    fill: "#000",
    fillRule: "nonzero",
    transform: "translate(-610 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_svg__(Logo)-Twitter",
    transform: "translate(610 378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_svg__Twitter-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter_svg__Shape",
    d: "M23.953 2.382c-.885.399-1.83.67-2.825.794A5.06 5.06 0 0 0 23.291.384a10 10 0 0 1-3.127 1.214A4.84 4.84 0 0 0 16.574 0c-2.718 0-4.92 2.259-4.92 5.041q.002.6.127 1.153C7.69 5.996 4.066 3.982 1.64.938a5.04 5.04 0 0 0-.666 2.538 5.08 5.08 0 0 0 2.188 4.2 4.8 4.8 0 0 1-2.228-.632v.062c0 2.445 1.693 4.485 3.946 4.95a4.9 4.9 0 0 1-2.212.086c.63 2.003 2.445 3.463 4.604 3.504A9.71 9.71 0 0 1 0 17.736 13.75 13.75 0 0 0 7.557 20c9.053 0 13.998-7.685 13.998-14.34 0-.214 0-.43-.015-.645.961-.707 1.8-1.6 2.46-2.613z"
  })))))));
};
export default SvgTwitter;